export const replaceElementWithBulk = function replaceElementWithBulk(array, oldElement, newElementsArray) {
  const oldElementIndex = array.indexOf(oldElement);
  if (oldElementIndex < 0) {
    return array;
  }
  return [...array.slice(0, oldElementIndex), ...newElementsArray, ...array.slice(oldElementIndex + 1)];
};
export const removeBulkInArray = function removeBulkInArray(array, toRemove) {
  return array.filter(el => !toRemove.includes(el));
};